const injectedEnvironment = process.env.ENVIRONMENT;
export const ENVIRONMENT =
  injectedEnvironment != null && String(injectedEnvironment).trim() !== ""
    ? injectedEnvironment
    : process.env.NODE_ENV === "production"
      ? "PROD"
      : "LOCAL";

const SENTRY_ENVIRONMENT_BY_APP_ENV = {
  LOCAL: "local",
  DEV: "dev",
  PROD: "prod",
};

export const isLocalEnvironment = (appEnvironment = ENVIRONMENT) => {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return true;
    }
  }

  return String(appEnvironment).toUpperCase() === "LOCAL";
};

export const resolveSentryEnvironment = (appEnvironment = ENVIRONMENT) => {
  const normalized = String(appEnvironment || "").trim().toUpperCase();
  if (!normalized) {
    return "unknown";
  }
  return (
    SENTRY_ENVIRONMENT_BY_APP_ENV[normalized] || normalized.toLowerCase()
  );
};

export const resolveSentryTunnel = (appEnvironment = ENVIRONMENT) => {
  if (isLocalEnvironment(appEnvironment)) {
    return "/sentry-tunnel";
  }

  return undefined;
};
